import { useSelector } from "react-redux";
import RegisterSectionRenderer from "./RegisterSectionRenderer";

function RegisterBank(props: any) {
    const commonIdState = useSelector((state: any) => state.commonId);
    const bankOptions = Array.isArray(commonIdState?.bankList)
        ? commonIdState.bankList
        : commonIdState?.bankList?.data || [];

    const resolveFieldOptions = (fieldItem: any) => {
        if (fieldItem?.name === "bank_id") {
            return bankOptions;
        }

        return undefined;
    };

    return <RegisterSectionRenderer {...props} resolveFieldOptions={resolveFieldOptions} />;
}

export default RegisterBank